export const getPathname = () => {
  return window.location.pathname;
};
export const getSearch = () => {
  return window.location.search;
};